import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { cloneDeep } from 'lodash';
import Select, { components } from 'react-select';
import {
  getTenantConfig,
  getRolePermissions,
  getAssignableSchools,
  editRole,
  getDistricts,
  getUserDashboardInfo,
  getAssignableStates,
} from '../../store/actions';
import ComponentHeader from '../ecap/ComponentHeader';
import { userProfileCopy } from '../../copy/advisor-dashboard/user-profile.json';
import {
  getAdminState,
  getAuthState,
  getUserTerritory,
  getOnboardingState,
} from '../../store/selectors';
import DropDownIndicator from '../utility/DropDownIndicator';
import territoriesJson from '../../util/countryTerritories.json';
import ChangesSaved from '../utility/ChangesSaved';
import CurrentRole from './user-profile-components/CurrentRole';

class EditRole extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      roleToChange: '',
      territory: '',
      highSchoolValues: [],
      highSchoolChecked: false,
      highSchools: [],
      hsDistrictValues: [],
      hsDisctrictChecked: false,
      hsDistricts: [],
      updateProfileSuccess: false,
      changesMade: false,
    };
  }

  customStyles = {
    control: (provided) => ({
      ...provided,
      height: '100%',
      borderRadius: '7px',
    }),
    option: (provided) => ({
      ...provided,
      color: this.props.tenant.primary,
    }),
    input: (provided) => ({
      ...provided,
      color: this.props.tenant.primary,
    }),
    placeholder: (provided) => ({
      ...provided,
      color: 'black',
      paddingLeft: '12px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: 'black',
      overflow: 'visible',
      paddingLeft: '12px',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      paddingRight: '6px',
    }),
    dropdownIndicator: (provided) => ({
      ...provided,
      color: this.props.tenant.primary,
    }),
    indicatorSeparator: (provided) => ({
      ...provided,
      display: 'none',
    }),
  };

  territories = async () => {
    if (
      this.props.advisorRole === 'Super User' ||
      this.props.advisorRole === 'Tenant Admin'
    ) {
      const territoryList = Object.values(territoriesJson);
      return territoryList.sort().map((territory) => {
        return { value: territory, label: territory };
      });
    }
    if (this.props.advisorRole === 'District Advisor') {
      return [{ value: 'Arizona', label: 'Arizona' }];
    }
    if (this.props.advisorRole === 'School Advisor') {
      const states = await this.props.getAssignableStates();
      return states.sort().map((territory) => {
        return { value: territory, label: territory };
      });
    }
  };

  handleSubmit = async () => {
    const { roleToChange, highSchoolValues, hsDistrictValues } = this.state;

    const schools = highSchoolValues;
    const districts = hsDistrictValues;

    const editInfo = {
      userToChange: this.props.admin.userProfileInfo,
      roleToChange,
      schools,
      districts,
    };

    await this.props
      .editRole(
        this.props.admin.userProfileInfo.tenantId,
        this.props.auth.jwtToken,
        editInfo
      )
      .then((res) => {
        if (res === 200) {
          this.setState(() => ({
            updateProfileSuccess: true,
            changesMade: false,
          }));
        }
      });

    this.props.getUserDashboardInfo(
      this.props.admin.userProfileInfo.id,
      this.props.admin.userProfileInfo.tenantId
    );
  };

  handleChange = (opt, stateValLength, stateVal) => {
    const allOptionsSelected =
      opt?.length === this.state[stateValLength]?.length;
    this.setState(() => ({
      highSchoolChecked: allOptionsSelected,
      [stateVal]: opt,
      updateProfileSuccess: false,
      changesMade: true,
    }));
  };

  get editableRoles() {
    if (
      !this.props.admin?.userProfileInfo?.tenant.features.includes('highschool')
    ) {
      const filteredRoles = this.props.admin.permissions.editableRoles.filter(
        (role) => {
          return !role.includes('School') && !role.includes('District');
        }
      );
      const editableRoleOptions = filteredRoles.map((role) => {
        return { value: role, label: role };
      });
      return editableRoleOptions;
    }
    const editableRoleOptions = this.props.admin.permissions.editableRoles.map(
      (role) => {
        return { value: role, label: role };
      }
    );
    return editableRoleOptions;
  }

  componentDidMount = async () => {
    await this.props.getRolePermissions(this.props.auth.jwtToken);
    this.setState({ roleToChange: this.props.admin.userProfileInfo?.role });
    this._isMounted = true;
    const districts = await this.props.getDistricts(
      'Arizona',
      this.props.admin.userProfileInfo.tenantId
    );
    const territories = await this.territories();
    this.setState(() => ({
      hsDistricts: districts,
      territories,
    }));
  };

  DropdownIndicator = () => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator styles={this.customStyles}>
          <DropDownIndicator color={this.props.tenant.primary} />
        </components.DropdownIndicator>
      )
    );
  };

  handleChangeInState = async (option, stateValue) => {
    this.setState({
      [stateValue]: option.value,
      updateProfileSuccess: false,
    });

    if (
      this.state.territory !== option.value ||
      this.state.roleToChange !== option.value
    ) {
      this.setState({
        highSchoolValues: [],
        hsDistrictValues: [],
      });
    }
    if (
      this.state.roleToChange !== option.value &&
      stateValue === 'roleToChange' &&
      this.state.territory.length > 0
    ) {
      const schools = await this.props.getAssignableSchools(
        this.state.territory,
        this.props.admin.userProfileInfo.tenantId
      );
      this.setState(() => ({
        highSchools: schools,
      }));
    }
    if (
      (this.state.roleToChange === 'School Advisor' ||
        this.state.roleToChange === 'School Admin') &&
      stateValue === 'territory'
    ) {
      const schools = await this.props.getAssignableSchools(
        option.value,
        this.props.admin.userProfileInfo.tenantId
      );
      this.setState({
        highSchools: schools,
      });
    }
    if (
      (this.state.roleToChange === 'District Advisor' ||
        this.state.roleToChange === 'District Admin') &&
      stateValue === 'territory'
    ) {
      this.setState({
        territory: 'Arizona',
      });
    }
  };

  componentWillUnmount = () => {
    this._isMounted = false;
  };

  handleCheckbox = (index, stateValue) => {
    this.setState((prevState) => {
      const clone = cloneDeep(prevState[stateValue]);
      clone[index].checked = !prevState[stateValue][index].checked;
      return { [stateValue]: clone };
    });
  };

  getPlaceholder = (role) => {
    if (role === 'District Admin' || role === 'District Advisor') {
      return 'Arizona';
    }
    if (this.state.territory.length > 0) {
      return this.state.territory;
    }
    return 'Select State';
  };

  isButtonDisabled = () => {
    const { roleToChange, highSchoolValues, hsDistrictValues } = this.state;

    if (this.props.admin.userProfileInfo?.role !== roleToChange) {
      if (
        (roleToChange === 'Student' ||
          roleToChange === 'Tenant Admin' ||
          roleToChange === 'Super User' ||
          roleToChange === 'College Advisor' ||
          roleToChange === 'College Advisor Manager') &&
        !this.state.updateProfileSuccess
      ) {
        return false;
      }
      if (
        (roleToChange === 'School Admin' ||
          roleToChange === 'School Advisor') &&
        highSchoolValues?.length > 0 &&
        this.state.territory.length > 0
      ) {
        return false;
      }
      if (
        (roleToChange === 'District Admin' ||
          roleToChange === 'District Advisor') &&
        hsDistrictValues?.length > 0
      ) {
        return false;
      }
    }

    if (!this.state.updateProfileSuccess && this.state.changesMade) {
      if (
        (roleToChange === 'School Admin' ||
          roleToChange === 'School Advisor') &&
        highSchoolValues?.length > 0 &&
        this.state.territory.length > 0
      ) {
        return false;
      }
      if (hsDistrictValues === null) {
        return true;
      }
      if (
        (roleToChange === 'District Admin' ||
          roleToChange === 'District Advisor') &&
        hsDistrictValues?.length !== 0
      ) {
        return false;
      }
    }

    return true;
  };

  render() {
    const {
      roleToChange,
      territory,
      highSchoolValues,
      highSchools,
      hsDistrictValues,
      hsDistricts,
    } = this.state;
    const { userProfileInfo } = this.props.admin;
    return (
      <div className="edit-role">
        <ComponentHeader
          parent="dashboard"
          headerText="Edit Role"
          tenant={this.props.admin.userProfileInfo.tenant}
        />
        {/* <CurrentRole /> */}
        <div className="select-display">
          <p>{userProfileCopy.editRoles.input1}</p>
          <Select
            components={this.DropdownIndicator}
            onChange={(option) => {
              this.handleChangeInState(option, 'roleToChange');
            }}
            options={this.editableRoles}
            className="edit-role-select"
            id="roleToChange"
            name="roleToChange"
            styles={this.customStyles}
            placeholder={roleToChange || 'Role'}
            aria-label={roleToChange || 'Role'}
          />
        </div>
        {(roleToChange === 'School Advisor' ||
          roleToChange === 'School Admin' ||
          roleToChange === 'District Admin' ||
          roleToChange === 'District Advisor') && (
          <>
            <div className="select-display">
              <p>{userProfileCopy.editRoles.input2}</p>
              <Select
                components={this.DropdownIndicator}
                onChange={(option) => {
                  this.handleChangeInState(option, 'territory');
                }}
                options={this.state.territories}
                className="edit-role-select"
                id="territory"
                name="territory"
                styles={this.customStyles}
                value={this.state.territory}
                placeholder={this.getPlaceholder(roleToChange)}
                aria-label={'Select State' || 'territory'}
                isDisabled={
                  roleToChange === 'District Admin' ||
                  roleToChange === 'District Advisor'
                }
              />
            </div>
          </>
        )}
        {(roleToChange === 'School Advisor' ||
          roleToChange === 'School Admin') &&
          !!territory && (
            <>
              <div className="edit-role__schools">
                <p className="school-label">
                  {userProfileCopy.editRoles.input3}
                </p>
                <Select
                  isMulti
                  onChange={(e) =>
                    this.handleChange(e, 'highSchools', 'highSchoolValues')
                  }
                  options={highSchools}
                  value={highSchoolValues}
                />
              </div>
            </>
          )}
        {(roleToChange === 'District Advisor' ||
          roleToChange === 'District Admin') && (
          <div className="edit-role__schools">
            <p className="school-label">{userProfileCopy.editRoles.input4}</p>
            <Select
              isMulti
              onChange={(e) =>
                this.handleChange(e, 'hsDistricts', 'hsDistrictValues')
              }
              options={hsDistricts}
              value={hsDistrictValues}
            />
          </div>
        )}
        <div className="bottom-row-container">
          <button
            type="button"
            tabIndex={0}
            className="button--primary save-changes"
            onClick={this.handleSubmit}
            onKeyDown={(e) => {
              if (['Enter'].includes(e.key)) this.handleSubmit();
            }}
            style={{
              color: 'white',
              borderColor: userProfileInfo?.tenant.primary,
              backgroundColor: userProfileInfo?.tenant.primary,
              padding: ' 0 34px',
            }}
            disabled={this.isButtonDisabled()}
          >
            {userProfileCopy.buttons.button1}
          </button>
          <ChangesSaved
            message={userProfileCopy.successMessage}
            stateValToDetermineShowing={this.state.updateProfileSuccess}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const tenant = getTenantConfig(state);
  const admin = getAdminState(state);
  const auth = getAuthState(state);
  const territory = getUserTerritory(state);
  const advisorRole = getOnboardingState(state).userData.user.role;
  return { tenant, admin, auth, territory, advisorRole };
}

export default withRouter(
  connect(mapStateToProps, {
    getRolePermissions,
    getAssignableSchools,
    editRole,
    getDistricts,
    getUserDashboardInfo,
    getAssignableStates,
  })(EditRole)
);
